// Generated static UI catalog. User-created content is intentionally not included.
module.exports = {
  "Popup was blocked. Allow popups for this site and try again.": "Popup blev blokeret. Tillad pop op-vinduer for dette websted, og pr\u00f8v igen.",
  "Popup was blocked. Please allow popups for this site and try again.": "Popup blev blokeret. Tillad venligst pop op-vinduer for dette websted, og pr\u00f8v igen.",
  "POST": "POST",
  "POST /v1/workflows": "POST /v1/workflows",
  "Post to channels, read history, and message users from workflow nodes through any of your saved Slack workspaces.": "Send til kanaler, l\u00e6s historik, og send beskeder til brugere fra workflow-knuder gennem et hvilket som helst af dine gemte Slack-arbejdsomr\u00e5der.",
  "Preset Nodes": "Forudindstillede knuder",
  "Press Ctrl+Enter to save.": "Tryk p\u00e5 Ctrl+Enter for at gemme.",
  "Preview": "Forh\u00e5ndsvisning",
  "Preview a file from URL": "Forh\u00e5ndsvis en fil fra URL",
  "Preview iframe not available.": "Eksempel iframe er ikke tilg\u00e6ngelig.",
  "Preview iframe not found.": "Eksempel iframe ikke fundet.",
  "preview snapshot": "forh\u00e5ndsvisning af snapshot",
  "Preview snapshot attached": "Forh\u00e5ndsvisning af snapshot vedh\u00e6ftet",
  "Primary": "Prim\u00e6r",
  "Privacy policy": "Privatlivspolitik",
  "Pro+": "Pro+",
  "Probe failed": "Sonde mislykkedes",
  "Probe logs": "Probe logs",
  "Probing": "Sonderende",
  "Probing workflows...": "Unders\u00f8ger workflows...",
  "Probing...": "Udforsker...",
  "Prompt & Changes": "Sp\u00f8rgsm\u00e5l og \u00e6ndringer",
  "Provide info before running": "Giv info f\u00f8r du k\u00f8rer",
  "Public Event Listener": "Offentlig begivenhedslytter",
  "Public run URL": "Offentlig k\u00f8re URL",
  "Publish": "Udgiv",
  "Publish a live version to make this endpoint runnable.": "Udgiv en liveversion for at g\u00f8re dette slutpunkt k\u00f8religt.",
  "Publish a new template": "Udgiv en ny skabelon",
  "Publish failed": "Udgivelsen mislykkedes",
  "Publish failed.": "Udgivelsen mislykkedes.",
  "Publish template": "Udgiv skabelon",
  "Publish the live version to the Template Store": "Udgiv liveversionen til skabelonbutikken",
  "Publish to Live": "Udgiv for at leve",
  "Publish to store": "Udgiv til butik",
  "Publish to Template Store": "Udgiv til skabelonbutik",
  "Published": "Udgivet",
  "Published (visible in the store)": "Udgivet (synlig i butikken)",
  "Publishing\u2026": "Udgiver...",
  "Quick start": "Hurtig start",
  "Rangeret efter antal eksekveringer": "Rangeret efter antal eksekveringer",
  "Rangeret efter antal k\u00f8rsler": "Rangeret efter antal k\u00f8rsler",
  "Re-analyze": "Genanalysere",
  "Re-pick": "Genvalg",
  "READ": "L\u00c6S",
  "READ + SET": "L\u00c6S + INDSTIL",
  "Read and import Browser Action workflows": "L\u00e6s og importer browserhandlingsarbejdsgange",
  "Read and write Uniconta ERP data (debtors, creditors, invoices, orders, inventory) from workflow nodes. Connect with your Company ID and API user \u2014 each connection is tied to one company.": "L\u00e6s og skriv Uniconta ERP-data (debitorer, kreditorer, fakturaer, ordrer, inventar) fra workflow-knuder. Opret forbindelse til dit firma-id og din API-bruger - hver forbindelse er knyttet til \u00e9n virksomhed.",
  "Reading the workflow\u2026": "L\u00e6ser workflowet...",
  "README \u2014 how to run this workflow (markdown)": "L\u00c6S MIG \u2014 hvordan du k\u00f8rer denne workflow (markdown)",
  "Recapture preview": "Genfang forh\u00e5ndsvisning",
  "Recording resumes the previous Browser Action\u2019s live setup tab and appends new steps.": "Optagelsen genoptager den tidligere browserhandlings fane for liveops\u00e6tning og tilf\u00f8jer nye trin.",
  "Recording\u2026 hover over elements in the opened tab": "Optager... hold mark\u00f8ren over elementer i den \u00e5bnede fane",
  "Redo": "Gentag",
  "Redraw": "Tegn igen",
  "Refresh": "Opdater",
  "Regenerate": "Regenerer",
  "Reject": "Afvis",
  "Reload": "Genindl\u00e6s",
  "Remember password": "Husk adgangskode",
  "Remove": "Fjern",
  "Remove attachment": "Fjern vedh\u00e6ftet fil",
  "Remove condition": "Fjern tilstand",
  "Remove field": "Fjern felt",
  "Remove from your saved list": "Fjern fra din gemte liste",
  "Remove image": "Fjern billede",
  "Remove item": "Fjern element",
  "Remove label": "Fjern etiketten",
  "Remove logo from this node": "Fjern logo fra denne knude",
  "Remove route": "Fjern ruten",
  "Remove step": "Fjern trin",
  "Removing...": "Fjerner...",
  "Removing\u2026": "Fjerner...",
  "Rename": "Omd\u00f8b",
  "Rename failed": "Omd\u00f8bning mislykkedes",
  "Rename param": "Omd\u00f8b param",
  "Rendering\u2026": "Gengiver...",
  "Replace": "Udskift",
  "Request": "Anmodning",
  "Request succeeded.": "Anmodningen lykkedes.",
  "Required": "P\u00e5kr\u00e6vet",
  "Required \u2014 add at least one output field.": "P\u00e5kr\u00e6vet \u2014 tilf\u00f8j mindst \u00e9t outputfelt.",
  "Reset on run": "Nulstil under l\u00f8b",
  "Reset zoom": "Nulstil zoom",
  "Resource created.": "Ressource oprettet.",
  "Resource does not exist.": "Ressource findes ikke.",
  "Response": "Svar",
  "Response Fields": "Svarfelter",
  "Response Length": "Svarl\u00e6ngde",
  "Response Template": "Svar skabelon",
  "REST API": "REST API",
  "Restore": "Gendan",
  "Restore planner": "Gendan planl\u00e6gger",
  "Restore this version as the current workflow": "Gendan denne version som den aktuelle workflow",
  "Restoring\u2026": "Gendanner...",
  "Resume": "Genoptag",
  "Resume Build": "Genoptag byggeri",
  "Retry": "Pr\u00f8v igen",
  "Retrying": "Pr\u00f8ver igen",
  "Retrying\u2026": "Pr\u00f8ver igen...",
  "Returns all workflows owned by the authenticated user, sorted by most recently updated.": "Returnerer alle workflows, der ejes af den godkendte bruger, sorteret efter senest opdateret.",
  "Returns the full workflow state including nodes, connections, and configuration.": "Returnerer den fulde workflow-tilstand inklusive knuder, forbindelser og konfiguration.",
  "Reusing": "Genbrug",
  "Review": "Gennemg\u00e5",
  "Review code": "Gennemg\u00e5 kode",
  "Review failed.": "Gennemgang mislykkedes.",
  "Revoke": "Tilbagekald",
  "Revoke API key?": "Tilbagekalde API-n\u00f8gle?",
  "Root group logic": "Rodgruppelogik",
  "Round": "Runde",
  "Route by yes/no rule": "Rute efter ja/nej-regel",
  "Route name...": "Rutenavn...",
  "Router": "Router",
  "Router-knuden": "Router-knuden",
  "Row must contain this text \u2014 text or @variable": "R\u00e6kken skal indeholde denne tekst \u2014 tekst eller @variabel",
  "Row:": "R\u00e6kke:",
  "Royal blue": "Kongebl\u00e5",
  "Run": "K\u00f8r",
  "Run & Wait": "L\u00f8b og vent",
  "Run an Apify Store actor": "K\u00f8r en Apify Store-skuespiller",
  "Run another flow as a node": "K\u00f8r et andet flow som en knude",
  "Run every (minutes)": "L\u00f8b hvert (minutter)",
  "Run from this node (fresh, no prior state)": "K\u00f8r fra denne knude (frisk, ingen tidligere tilstand)",
  "Run log": "K\u00f8r log",
  "Run the workflow first": "K\u00f8r f\u00f8rst workflowet",
  "Run the workflow to gather live evidence?": "K\u00f8re workflowet for at indsamle levende beviser?",
  "Run workflow": "K\u00f8r workflow",
  "Run, pause, resume, and stop workflows": "K\u00f8r, s\u00e6t p\u00e5 pause, genoptag og stop workflows",
  "Running your workflow...": "K\u00f8rer dit arbejdsflow...",
  "Running...": "K\u00f8rer...",
  "Runtime Log Chat": "Runtime Log Chat",
  "Save": "Gem",
  "Save & Start QA": "Gem og start QA",
  "Save as reusable preset node": "Gem som genanvendelig forudindstillet knude",
  "Save changes": "Gem \u00e6ndringer",
  "Save failed": "Gem mislykkedes",
  "Save failed.": "Gem mislykkedes.",
  "Save Page": "Gem side",
  "Saved": "Gemt",
  "Saved.": "Gemt.",
  "Saving...": "Gemmer...",
  "Saving\u2026": "Gemmer...",
  "Scheduled Runs": "Planlagte k\u00f8rsler",
  "Scheduler": "Planl\u00e6gger",
  "Screenshots (optional)": "Sk\u00e6rmbilleder (valgfrit)",
  "Script": "Script",
  "Scroll duration (ms)": "Rullevarighed (ms)",
  "Se API-dokumentation eller kontakt support.": "Se API-dokumentation eller kontakt support.",
  "Sea green": "Havgr\u00f8n",
  "Search": "S\u00f8g",
  "Search by username or email\u2026": "S\u00f8g efter brugernavn eller e-mail...",
  "Search templates": "S\u00f8g skabeloner",
  "Search the Apify Store (e.g. web scraper)\u2026": "S\u00f8g i Apify Store (f.eks. webskraber)...",
  "Search workflows": "S\u00f8g workflows",
  "Searching\u2026": "S\u00f8ger...",
  "Seconds": "Sekunder",
  "Select a node to choose which connected account it uses.": "V\u00e6lg en knude for at v\u00e6lge, hvilken tilsluttet konto den bruger.",
  "Select all": "V\u00e6lg alle",
  "Select at least one permission.": "V\u00e6lg mindst \u00e9n tilladelse.",
  "Select category": "V\u00e6lg kategori",
  "Select Field": "V\u00e6lg Felt",
  "SELECT FIELD": "V\u00c6LG FELT",
  "Select subcategory": "V\u00e6lg underkategori",
  "Select\u2026": "V\u00e6lg...",
  "Send": "Send",
  "Send (Enter)": "Send (Enter)",
  "Send answer": "Send svar",
  "Send feedback": "Send feedback",
  "Sending\u2026": "Sender...",
  "Service": "Service",
  "Set": "S\u00e6t",
  "SET": "S\u00c6T",
  "Set to variable": "Indstil til variabel",
  "Set Variable": "Indstil variabel",
  "Settings": "Indstillinger",
  "Setup instructions (markdown)": "Ops\u00e6tningsinstruktioner (markdown)",
  "Setup steps, variables to set, sheets to create, accounts to connect\u2026": "Ops\u00e6tningstrin, variabler der skal indstilles, ark der skal oprettes, konti der skal forbindes...",
  "SharePoint": "SharePoint",
  "Ship automations, not setup time.": "Skibsautomatiseringer, ikke ops\u00e6tningstid.",
  "Show": "Vis",
  "Show all": "Vis alle",
  "Show all parameters": "Vis alle parametre",
  "Show curl preview": "Vis forh\u00e5ndsvisning af kr\u00f8lle",
  "Show less": "Vis mindre",
  "Show more": "Vis mere",
  "Show run log": "Vis k\u00f8rselslog",
  "Show the UI page powered by this workflow": "Vis brugerfladesiden, der drives af denne workflow",
  "Show the workflow editor": "Vis workflow-editoren",
  "Sidst opdateret:": "Sidst opdateret:",
  "Sign in": "Log ind",
  "Sign in to Alleflow": "Log ind p\u00e5 Alleflow",
  "Sign in to approve": "Log ind for at godkende",
  "Sign in to install": "Log ind for at installere",
  "Sign in to manage the Template Store.": "Log ind for at administrere skabelonbutikken.",
  "Sign in to your Alleflow account, then you will return here to approve the Chrome extension.": "Log ind p\u00e5 din Alleflow-konto, s\u00e5 vender du tilbage hertil for at godkende Chrome-udvidelsen.",
  "Sign out": "Log ud",
  "Sign out of": "Log ud af",
  "Sign up": "Tilmeld dig",
  "Signed in": "Logget ind",
  "Signing in\u2026": "Logger ind...",
  "Shopify": "Shopify",
  "Simpel tilstand": "Simpel tilstand",
  "Simpel vs. avanceret tilstand": "Simpel vs. avanceret tilstand",
  "Simple": "Simpelt",
  "Select all that apply": "Vælg alle, der passer",
  "Skip": "Spring over",
  "Skip the intro": "Spring introen over",
  "Skip this step if it fails": "Spring dette trin over, hvis det mislykkes",
  "Skriv en kort instruktion der hjaelper AI-modellen med at forsta konteksten, f.eks. \"Klassificer kundens feedback som positiv, negativ eller neutral.\"": "Skriv en kort instruktion der hjaelper AI-modellen med at forsta konteksten, f.eks. \"Klassificer kundens feedback som positiv, negativ eller neutral.\"",
  "Skriv en variabel i kode": "Skriv en variabel i kode",
  "Sky blue": "Himmelbl\u00e5",
  "Slack": "Slap",
  "Sleep": "Sov",
  "Snapshot preview": "Snapshot forh\u00e5ndsvisning",
  "Snit pr. k\u00f8rsel": "Snit pr. k\u00f8rsel",
  "Soft coral": "Bl\u00f8d koral",
  "Something went wrong on our side.": "Noget gik galt p\u00e5 vores side.",
  "Something went wrong. Please try again.": "Noget gik galt. Pr\u00f8v venligst igen.",
  "Sort order": "Sorteringsr\u00e6kkef\u00f8lge",
  "Sort templates": "Sorter skabeloner",
  "Source": "Kilde",
  "Source workflow": "Kilde workflow",
  "Staging": "Iscenes\u00e6ttelse",
  "Staging saves": "Iscenes\u00e6ttelse gemmer",
  "Start": "Start",
  "Start at": "Start kl",
  "Start en korsel. Send input-parametre som JSON body.": "Start en korsel. Send input-parametre som JSON body.",
  "Start input": "Start input",
  "Start parameters": "Start parametre",
  "Start QA on the new workflow?": "Vil du starte QA p\u00e5 den nye workflow?",
  "Start URL": "Start URL"
};
